// return a new object that is only the specified keys of the input object
//
const selectKeys = (...keys) => input => Object.keys(input)
	.filter(key => keys.includes(key))
	.reduce((acc, key) => ({ ...acc, ...{ [key]: input[key] } }), {})

export default selectKeys



// WEBPACK FOOTER //
// ./src/utilities/Data/selectKeys.js